import * as React from 'react'
import { ActionCreator } from 'redux'
import { FormikState } from 'formik'
import { History } from 'history'
import { Redirect } from 'react-router-dom'

import { LoginTriggerAction } from '../../../actions'
import LoginForm, { Values } from '../../../containers/pages/LoginForm/LoginForm'

// import { Logo } from '../../common/Logo/Logo'
const AxaInsuranceLogo = require('../../../images/logo/AxaInsuranceLogo_55.png')

import { LoginWrapper } from './components/LoginWrapper/LoginWrapper'
import { StyledLink } from './components/Link/Link.glamorous'

export type Props = {
  error: any;
  history: History;
  loading: boolean;
  login: ActionCreator<LoginTriggerAction>;
  userSession: object;
  userError: string;
  recoverSuccess: any;
}

export const Login: React.SFC<Props & FormikState<Values>> = (props) => {
  /**
   * Check if there's any session active
   * if is Redirect to /dashboard
   */
  if (Object.keys(props.userSession).length !== 0) {
    return (<Redirect to="/dashboard" />)
  }else {
    return (
        <LoginWrapper>
          {/* <Logo /> */}
          <img src={AxaInsuranceLogo} alt="AXA INSURANCE" className={''} />
          <LoginForm {...props} />
          <StyledLink to="/forgot">Forgot password?</StyledLink>
        </LoginWrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Login/Login.tsx